export default "/images/Grolman_Root.webp?0cf903e8f312ff3e83cde9ecb6d23410";